jQuery.noConflict();
(function( $ ) {
    $(function() {
    //Document Ready STARTS

        var wdata = [];
        wdata.mobileWidth = 640;
        wdata.debug = false;
        wdata.afterLoad = false;
        wdata.swiper = [];
        var slxhr = null,
            bkxhr = null,
            pages = null;

        //PLACEHOLDERS
        $('input, textarea').placeholder(); //add placeholders for load browsers

        function afterLoad() {
            svgSupport();
            toggleVAT();
            updateWData();
            lazyBg();
            useLargeImages();
            runsSliders();
            bindClick();
            wdata.afterLoad = true;
            $('.mobile-menu').attr('style', '');
            if (wdata.ww < wdata.mobileWidth) {
                $('body').removeClass('filter-on');
            }
            removeSplash();
            getBulkSaveStatus();
            if ($('.ajax-slider').length>0) {
                setTimeout(function(){
                    getAjaxSliders();
                }, 800);
            }
            setTimeout(function(){
                window.dispatchEvent(new Event('resize'));
                var drillWidth = wdata.ww,
                    drillHeight = wdata.wh - 130;
                if (drillWidth > 390) {
                    drillWidth = 390;
                }
                $('.mobile-menu  div.is-drilldown > ul').foundation('_destroy');
              //  $('.mobile-menu .is-drilldown').attr('style', 'width: '+drillWidth+'px; height: '+drillHeight+'px;');
            }, 1500);

        }

        afterLoad();

        // Functions On Window resize
        $(window).on('resize', function(){
            updateWData();
            lazyBg();
        });

        // Window scroll
        $(window).on('scroll', function(){
            wdata.scrollTop = $(window).scrollTop();
            lazyBg();
        });

        // mobile mnu toggle functions
        $('.menu-toggle').on('click enter', function(e){
            e.preventDefault();
            $(this).toggleClass('is-active');
            $('.mobile-menu').toggleClass('active');
            $('body').toggleClass('mobile-menu-active');
        });

        $('.menu-toggle').one('click', function(e){
            var drill = new Foundation.Drilldown($('.nav-wrap > ul'));
        });

        $('a.mtoggle-btn').on('click enter', function(e){
            e.preventDefault();
            $('.menu-toggle').trigger('click');
        });

        $('.menu-toggle-close').on('click enter', function(){
            $('.menu-toggle').trigger('click');
        });

        $('.share-toggle').on('click enter', function(){
            $(this).toggleClass('active');
            $('.share-block').slideToggle();
        });

        $('body').on('click', '.copyToClipboard', function(e){
            e.preventDefault();
            $(this).html('<span class="icon-share"></span>');
            element = $(this).data('target');
            var $temp = $("<input>");
            $("body").append($temp);
            $temp.val($(element).val()).select();
            document.execCommand("copy");
            $temp.remove();
        });

        //Adjust Header spacer height
        function spacerHeight() {
            var headerHeight = $('.header').outerHeight();
            $('.header-spacer').height(headerHeight);
        }

        //Check if DOM has MAP
        if(($('#map').data('lat') != '') && ($('#map').data('lat') != undefined)) {
            initMap();
        }

        function removeSplash() {
            $( '.splishs-plash-splosh').fadeTo( 'fast' , 0.1, function() {
                $( '.splishs-plash-splosh').remove();
            });
        }

        /* Run sliders */
        function runsSliders() {

            if ($('.flexslider.product-images').length>0) {
                if ($('.flexslider.product-images').hasClass('has-thumbs')) {
                    $('#carousel').flexslider({
                        animation: "slide",
                        controlNav: false,
                        animationLoop: false,
                        slideshow: false,
                        itemWidth: 156,
                        itemMargin: 0,
                        prevText: '',
                        nextText: '',
                        asNavFor: '#slider'
                    });

                    $('#slider').flexslider({
                        animation: "slide",
                        controlNav: false,
                        animationLoop: false,
                        slideshow: false,
                        prevText: '',
                        nextText: '',
                        sync: "#carousel"
                    });
                }
                else {
                    $('.flexslider.product-images').flexslider({
                        directionNav: false,
                        controlNav: true,
                        animationLoop: false,
                        slideshow: false,
                        animation: "slide",
                        prevText: '',
                        nextText: '',
                        smoothHeight: true,
                        controlsContainer: "#product-images",
                        manualControls: "ul.pg li"
                    });
                }
            }

            //Top slider
            if ($('.top-sw-slider').length>0) {
                $.each($('.top-slider .swiper-container'), function(e){
                    var sliderId = $(this).attr('id'),
                        rowId = $(this).attr('data-id');
                 //   console.log('init #'+sliderId);
                    if (sliderId != undefined && sliderId != '') {
                        wdata.swiper[sliderId] = new Swiper('#'+sliderId, {
                            navigation: {
                                nextEl: '.next-'+rowId,
                                prevEl: '.prev-'+rowId,
                            },
                            pagination: {
                                el: ".swiper-pagination",
                                clickable: true,
                            },
                        });
                    }
                });

            }

            // Products sliders
            var centerSlides = false;
            var starSlide = 0;
            if (wdata.ww < wdata.mobileWidth) {
                centerSlides = true;
                starSlide = 1;
            }
            $.each($('.sw-wrap .swiper-container'), function(e){
                var sliderId = $(this).attr('id'),
                    rowId = $(this).attr('data-id'),
                    spacer = 0;
                if ($(this).hasClass('categories-slider')) {
                    spacer = 30;
                }
                console.log(sliderId);
                if (sliderId != undefined && sliderId != '') {
                    wdata.swiper[sliderId] = new Swiper('#'+sliderId, {
                        slidesPerView: 'auto',
                        centeredSlides: centerSlides,
                        initialSlide: starSlide,
                        spaceBetween: spacer,
                        speed: 600,
                        autoplay: {
                            delay: 5000,
                        },
                        navigation: {
                            nextEl: '.next-'+rowId,
                            prevEl: '.prev-'+rowId,
                        },
                    });
                }
            });
        }

        $( document.body ).on('sc_ajax_sliders_ready', function(){
            runAjaxSliders();
        });

        function runAjaxSliders() {
            var centerSlides = false;
            var starSlide = 0;
            if (wdata.ww < wdata.mobileWidth) {
                centerSlides = true;
                starSlide = 1;
            }
            $.each($('.ajax-slider .sw-wrap .swiper-container'), function(e){
                var sliderId = $(this).attr('id'),
                    rowId = $(this).attr('data-id');
                if (sliderId != undefined && sliderId != '') {
                    wdata.swiper[sliderId] = new Swiper('#'+sliderId, {
                        slidesPerView: 'auto',
                        centeredSlides: centerSlides,
                        initialSlide: starSlide,
                        spaceBetween: 0,
                        speed: 600,
                        autoplay: {
                            delay: 5000,
                        },
                        navigation: {
                            nextEl: '.next-'+rowId,
                            prevEl: '.prev-'+rowId,
                        },
                    });
                }
            });
        }

        function getAjaxSliders(){
            var rq = {};
            $.each($('.ajax-slider'), function(){
                var id = $(this).attr('id'),
                    products = $(this).attr('data-products'),
                    row = $(this).attr('data-sid');
                if (id != undefined && products != undefined && row != undefined) {
                    var record = {'id': id,'products': products,'row':row};
                    rq[id] = record;
                }
            });

            if ( slxhr != null ) {
                slxhr.abort();
                slxhr = null;
            }
            slxhr = $.ajax({
                url: ajax_url,
                timeout: 12000,
                type: 'GET',
                cache: false,
                data: ({
                    action: 'sc_get_sliders',
                    data: rq,
                }),
                beforeSend: function() {
                },
                success: function(data) {
                    var sliders = decodeJSON(data);
                    $.each(sliders, function(id, dt){
                        $('#'+id).html(dt.slider);
                    });
                    $( document.body ).trigger('sc_ajax_sliders_ready');
                    getBulkSaveStatus();
                },
                error: function( jqXHR, textStatus, errorThrown ) {
                    console.log( 'The following error occured: ' + textStatus, errorThrown );
                },
                complete: function( jqXHR, textStatus ) {
                }
            });
            //console.log(rq);
        }

        function getBulkSaveStatus() {
            if ($('.bks').length>0) {
                var bksids = [];
                $.each($('.bks'), function(){
                    var bksID = $(this).attr('data-pid');
                    if (bksID != undefined && bksID != '') {
                        bksids.push(bksID);
                    }
                });

                if(bksids.length > 0) {
                    if ( bkxhr != null ) {
                        bkxhr.abort();
                        bkxhr = null;
                    }
                    bkxhr = $.ajax({
                        url: ajax_url,
                        timeout: 12000,
                        type: 'POST',
                        cache: false,
                        data: ({
                            action: 'sc_bulk_offers',
                            ids: bksids,
                        }),
                        beforeSend: function() {
                        },
                        success: function(data) {
                            setBulkSaveStatus(data);
                        },
                        error: function( jqXHR, textStatus, errorThrown ) {
                            console.log( 'The following error occured: ' + textStatus, errorThrown );
                        },
                        complete: function( jqXHR, textStatus ) {
                        }
                    });
                }
            }
        }

        function setBulkSaveStatus(data) {
            var arr = decodeJSON(data),
                msg = arr.text,
                title = arr.title,
                productIDS = arr.status;
            $.each(productIDS, function(id, status){
                if ($('#bks-'+id).length>0) {
                    if (status == '1') {
                        var bulkBtn = '<div class="button bulkeq bulk-save" data-pid="'+id+'" title="'+title+'">'+msg+'</div>';
                    }
                    else {
                        var bulkBtn = '<div class="bulkeq no-bk-save"></div>';
                    }
                    $('#bks-'+id).replaceWith(bulkBtn);
                }
            });

            $(window).trigger('resize');
            if ($('.products-loop').length>0) {
       //         $('.products-loop').foundation('destroy');
                $('.products-loop').foundation();
            }
        }


        //init MAP with custom settings
        function initMap() {

            var $mapDiv = $('#map'),
                lat = $mapDiv.data('lat'),
                lan = $mapDiv.data('lan'),
                zoom = $mapDiv.data('zoom'),
                marker = $mapDiv.data('marker'),
                title = $mapDiv.data('title'),
                windowHeight = $( window ).height(),
                mapHeight =  (windowHeight/2) - 150;

            //set map height to half window height
            if (mapHeight<400) {
                mapHeight = 400;
            }

            $mapDiv.height(mapHeight);

            if($('body').hasClass('mobile')) {
                var optionNavigationControl = false,
                    optionTypeControl = false,
                    optionScaleControl = false,
                    optionDraggable = false,
                    optionScrollwheel = false;
            }
            else {
                var optionNavigationControl = false,
                    optionTypeControl = true,
                    optionScaleControl = true,
                    optionDraggable = true,
                    optionScrollwheel = false;
            }

            var myLatLng = {lat: lat, lng: lan};
            var map = new google.maps.Map(document.getElementById('map'), {
                zoom: zoom,
                // mapTypeId: google.maps.MapTypeId.SATELLITE,
                navigationControl: optionNavigationControl,
                mapTypeControl: optionTypeControl,
                scaleControl: optionScaleControl,
                draggable: optionDraggable,
                scrollwheel: optionScrollwheel,
                center: myLatLng
            });

            var markerImage = new google.maps.MarkerImage(marker,
                new google.maps.Size(41, 61), //size
                new google.maps.Point(0, 0), //origin point
                new google.maps.Point(20, 61)); // offset point

            var marker = new google.maps.Marker({
                position: myLatLng,
                map: map,
                icon: markerImage,
                title: title
            });
        }

                if ($('#open-map').length>0) {
            initOpenStreetMap();
        }

        function initOpenStreetMap(){
            var mapHeight = getWindowHeight() * 0.4;
            if (mapHeight < 400) {
                mapHeight = 400;
            }

            $('#open-map').css( 'height', mapHeight);
            map = L.map('open-map').setView([omap.center_lat, omap.center_lng], omap.zoom);

            // add an OpenStreetMap tile layer
            var tile = L.tileLayer('https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>'
            });
            tile.addTo(map);
            addOpenMarkers();
        };

        function addOpenMarkers() {
            var markers = omap.markers;
            var imgUrl = $('#open-map').attr('data-marker');
            var mapIcons = [];
            mapIcons['st'] = L.icon({
                iconUrl: imgUrl,
                iconSize: [30, 50]
            });
/*            mapIcons['w'] = L.icon({
                iconUrl: imgUrl + 'status-s-w.png',
                iconSize: [20, 20]
            });
            mapIcons['wr'] = L.icon({
                iconUrl: imgUrl + 'status-s-wr.png',
                iconSize: [20, 20]
            });*/

            for (var i=0; i < markers.length; i++) {
                var lat = markers[i].lat,
                    lng = markers[i].lng,
                    markerTitle = markers[i].default_label;
                L.marker([ lat, lng ], {title: markerTitle, icon: mapIcons['st'] }).addTo(map);
            }
        }

        //click trigger
        function bindClick() {
            $('.clickTrigger').on('click', function(e) {
                e.preventDefault();
                var targetLine = $(this).data('target');
                var $target = $( targetLine);
                $target.trigger( "click" );

            });
        }

        //Scroll to el if page has Hash
        if(window.location.hash) {
            var hash = window.location.hash;
            if ($(hash).length>0) {
                scrollToEl(hash, 220);
            }
        }

        //function scroll to element
        function scrollToEl(target, offset) {
            var $target = $(target);
            $("html, body").animate({ scrollTop: $target.offset().top - (offset + 70)}, 1000);
        }

        function toggleVAT(){
            var vatStatus = getCookie('vat');
            if (vatStatus == 'ex') {
                $('body').removeClass('vat-inc');
                $('body').addClass('vat-ex');
                $('#inc-vat').prop('checked', true);
                setCookie('vat', 'ex');
            }
            else  {
                $('body').addClass('vat-inc');
                $('body').removeClass('vat-ex');
                $('#inc-vat').prop('checked', false);
                setCookie('vat', 'inc');
            }

            $('#inc-vat').on('change', function(){
                var status = false;
                if ($(this).is(":checked")) {
                    status = true;
                }
                if (status ==  true) {
                    $('body').removeClass('vat-inc');
                    $('body').addClass('vat-ex');
                    setCookie('vat', 'ex');
                }
                else {
                    $('body').addClass('vat-inc');
                    $('body').removeClass('vat-ex');
                    setCookie('vat', 'inc');
                }
            });
        }

        function updateWData() {
            wdata.ww = getWindowWidth();
            wdata.wh = getWindowHeight();
            wdata.scroll =  $(window).scrollTop();

            if (wdata.debug == true) {
                console.info('updateWData');
                console.log(wdata);
            }
        }

        //window height
        function getWindowHeight() {
            return $( window ).height();
        }

        //window width
        function getWindowWidth() {
            return $( window ).width();
        }

        //validate Phone
        function validatePhone(phone) {
            var re = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;
            return re.test(phone);
        }

        //validate Email
        function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }

        /* CHnage figure backgrounds on different screen sizes */
        function useLargeImages() {
            if (wdata.ww > 1366) {
                $.each($('.large-bg-image'), function(){
                    var large = $(this).attr('data-large');
                    if (large != undefined && large != '') {
                        $(this).attr('style', 'background-image: url('+large+');');
                    }
                });
            }
            else if (wdata.ww > 640) {
                $.each($('.large-bg-image'), function(){
                    var large = $(this).attr('data-src');
                    if (large != undefined && large != '') {
                        $(this).attr('style', 'background-image: url('+large+');');
                    }
                });
            }
        }

        function lazyBg(){
            var TopPos = $(window).scrollTop(),
                BottomPos = TopPos + $(window).height();
            var use = 'src';
            if (wdata.ww > 1200) {
                use = 'large';
            }
            $.each($('.lazy-bg.blur'), function() {
                    var TopElement = $(this).offset().top,
                        BotElement = TopElement + $(this).height();
                    if ((BotElement <= BottomPos) && (TopElement >= TopPos)) {
                        var imgSrc = $(this).attr('data-'+use);
                        if (imgSrc != undefined) {
                            $(this).attr('style', 'background-image: url('+imgSrc+');').removeClass('blur').addClass(use);
                       //     console.log(imgSrc);
                        }
                    }

/*                var TopElement = $(this).offset().top,
                    BotElement = TopElement + $(this).height();

                return ((BotElement <= BotView) && (TopElement >= TopView));*/
            });
        }

        //check if element is visible #element, .element
        function isElementVisible(elementToBeChecked) {
            var TopView = $(window).scrollTop();
            var BotView = TopView + $(window).height();
            var TopElement = $(elementToBeChecked).offset().top;
            var BotElement = TopElement + $(elementToBeChecked).height();
            return ((BotElement <= BotView) && (TopElement >= TopView));
        }

        function svgSupport() {
            if (typeof SVGRect != "undefined") {
                $('body').addClass('svg');
                var status = true,
                    svgLogo = $('.logo_link img').attr('data-svg');
                if (svgLogo != undefined && svgLogo != '') {
                    $('.logo_link img').attr('src', svgLogo);
                }
            }
            else {
                $('body').addClass('no-svg');
                var status = false;
            }
            if (window.devicePixelRatio > 1.3) {
                $('body').addClass('retina');
            }
            return status;
        }

        /* Get Cookie */
        function getCookie(name) {

            if (typeof(Storage) !== "undefined") {
                if (wdata.isPrivate == 1) {
                    var cookie = wdata[name];
                }
                else {
                    cookie = localStorage.getItem(name);
                }
            }
            else {
                var cookie = $.cookie(name);
                if (cookie == '') {
                    cookie = null;
                }
            }
            return cookie;
        }

        /* Set Cookie*/
        function setCookie(name, val, expires){

            if (typeof(Storage) !== "undefined") {
                if (wdata.isPrivate == 1) {
                    wdata[name] = val;
                }
                else {
                    localStorage.removeItem(name);
                    localStorage.setItem(name, val);
                }
            }
            else {
                if (expires == '' || expires == 'undefined') {
                    var expires = 7;
                }
                $.cookie(name, val, { expires: expires, path: '/' });
            }
            return true;
        }

        function deleteCookie(name) {
            if (typeof(Storage) !== "undefined") {
                if (wdata.isPrivate == 1) {
                    wdata[name] = undefined;
                }
                else {
                    localStorage.removeItem(name);
                }
            }
            else {
                if (expires == '' || expires == 'undefined') {
                    var expires = 7;
                }
                $.removeCookie(name, { path: '/' });
            }
        }

        /* USER LOGIN start */
        $('form#login').on('submit', function(e){
            e.preventDefault();
            $('#login p.status').removeClass('alert');
            $('#login p.status').addClass('prg');
            $('form#login button[type=submit]').attr('disabled', 'disabled');
            $('form#login p.status').show().html('Trying login as <strong>'+$('form#login #username').val()+'</strong>');
            $.ajax({
                type: 'POST',
                dataType: 'json',
                url: ajax_url,
                data: {
                    'action': 'ajaxlogin', //calls wp_ajax_nopriv_ajaxlogin
                    'username': $('form#login #username').val(),
                    'password': $('form#login #password').val(),
                    'g-recaptcha-response': $('form#login #g-recaptcha-response').val(),
                    'redirect': $('form#login #redirect').val(),
                    'stone_captcha': $('form#login #stone_captcha').val(),
                    'security': $('form#login #security').val() },
                success: function(data){
                    //     console.log(data);
                    $('form#login button[type=submit]').removeAttr('disabled');
                    $('form#login p.status').text(data.message);
                    if (data.loggedin == true){
                        // console.log('Redirect to '+data.redirect);
                        document.location.href = data.redirect;
                        $('#login p.status').addClass('success');
                        $('#login p.status').removeClass('prg');
                    }
                    else {
                        $('#login p.status').removeClass('prg');
                        $('#login p.status').addClass('alert');
                    }
                }
            });
            e.preventDefault();
        });
        $('form#login button[type=submit]').removeAttr('disabled');
        /* USER LOGIN end */

        /* USER REGISTER start */
        $('form#register').on('submit', function(e){
            e.preventDefault();
            $('#register p.status').removeClass('alert');
            $('#register p.status').addClass('prg');
            $('form#register button[type=submit]').attr('disabled', 'disabled');
            $('form#register p.status').show().html('Trying create account <strong>'+$('form#register #username').val()+'</strong>');
            $.ajax({
                type: 'POST',
                dataType: 'json',
                url: ajax_url,
                data: {
                    'action': 'ajaxregister', //calls wp_ajax_nopriv_ajaxlogin
                    'username': $('form#register #username').val(),
                    'email': $('form#register #email').val(),
                    'password': $('form#register #password').val(),
                    'password2': $('form#register #password2').val(),
                    'g-recaptcha-response': $('form#register #g-recaptcha-response').val(),
                    'redirect': $('form#register #redirect').val(),
                    'stone_captcha': $('form#register #stone_captcha').val(),
                    'security': $('form#register #security').val() },
                success: function(data){
                         console.log(data);
                    $('form#register button[type=submit]').removeAttr('disabled');
                    $('form#register p.status').text(data.message);
                    if (data.register == true){
                        // console.log('Redirect to '+data.redirect);
                        document.location.href = data.redirect;
                        $('#register p.status').addClass('success');
                        $('#register p.status').removeClass('prg');
                    }
                    else {
                        $('#register p.status').removeClass('prg');
                        $('#register p.status').addClass('alert');
                    }
                }
            });
            e.preventDefault();
        });
        $('form#register button[type=submit]').removeAttr('disabled');
        /* USER REGISTER end */

        $('#apply-for-trade').on('click', function(e){
            e.preventDefault();
            var uid = $(this).attr('data-uid');
            if (uid != '') {
                $.ajax({
                    type: 'POST',
                    dataType: 'json',
                    url: ajax_url,
                    data: {
                        'action': 'trademember_apply',
                        'uid': uid
                    },
                    success: function(data){
                        $('.not-trade-user p.text-center').html(data.message);
                        setTimeout(function(){
                            location.reload();

                        }, 1000);
                    }
                });
            }
        });

        function populateFaq(){
            var getParams = searchParams(window.location.href);
            console.log(getParams);
            if (getParams['faq-search'] != undefined) {
                $('.faq-search input[name=faq-search]').val(getParams['faq-search']);
                $('.search-form.faq-search').trigger('submit');
            }
        }

        if (window['qmap'] != undefined) {
/*            $('.faq-search input[type=search]').on('keyup', function() {
                var text = $(this).val();
                var resultObject = findItem(text);
                displayResults(resultObject);
            });*/

            $('.search-form.faq-search').on('submit', function(e){
                e.preventDefault();
                var text = $('.faq-search input[name=faq-search]').val();
                var resultObject = findItem(text);
                displayResults(resultObject);
            });

            populateFaq();
        }

        function findItem(term) {
            var options = {
                shouldSort: true,
                threshold: 0.3,
                location: 0,
                distance: 100,
                maxPatternLength: 32,
                minMatchCharLength: 1,
                keys: [{
                    name: 'question',
                    weight: 0.8
                }, {
                    name: 'answer',
                    weight: 0.7
                }]
            };

            var fuse = new Fuse(qmap, options); // "list" is the item array

            var result = fuse.search(term);
            result.sort(function(a, b){
                if(a.Product < b.Product) return -1;
                if(a.Product > b.Product) return 1;
                return 0;
            });
            return result;
        }

        function setLink(query) {
            if (parentUrl != undefined && parentUrl != '') {
                var uri = new URI(parentUrl + query);
            }
            if(uri.toString()!=window.location.href){
                window.history.pushState({path:uri.toString()},'',uri.toString());
            }
        }
        function displayResults(arr) {
            if (arr.length > 0) {
                $('.accordion li').hide();
                $.each(arr, function(k,v){
                    var item = v.item,
                        qid = item.q;
                    setTimeout(function(){
                        $('#'+qid).slideToggle();
                    }, 500);
                });
            }
            else {
                $('.accordion li').show();
            }
        }

/*        $('.read-more').each(function() {
            var $el = $(this),
                maxHeight = $el.data('max-height');
            if ( maxHeight == undefined || maxHeight * 1 < 1 ) {
                maxHeight = 110;
            }
            if ( $el.height() > maxHeight ) {
                var html = '<div class="inner" style="max-height: ' + maxHeight +'px;" data-height="' + $el.height() + '">' + $el.html();
                html += '<p class="expand"><a class="button">Read More</a></p></div>';
                $(this).html(html);
            }
            else {
                //console.log($el.height());
            }
           // console.log($el.html());
        });
        $('.read-more').on('click', '.expand .button', function() {
            var $el = $(this).closest('.read-more').find('.inner'),
                targetHeight = $el.data('height');
            $el.animate( { maxHeight: targetHeight, marginBottom: 0 }, 300, function() {
                $el.find('.expand').fadeOut(100);
                $el.attr('style', 'overflow: visible;');
            });
        });*/


        if ($('nav.ajax-nav').length> 0 && window['ajax_nav_settings'] != undefined) {
            var ajax_nav = window['ajax_nav_settings'];
            $('.ajax-nav').show();
            console.log('ajax-nav-init');
            $('body').on('click', '.ajax-nav a.page-numbers', function(e){
                e.preventDefault();
                var page = parseInt(ajax_nav['current']);
                if ($(this).hasClass('prev')) {
                    page = page - 1;
                }
                else if ($(this).hasClass('next')) {
                    page = page + 1;
                }
                else {
                    page = $(this).text();
                }
                ajax_nav['current'] = page;
                ajax_paginate(page);
            });
        }

        function ajax_paginate(thePg){
            console.log('ajax_paginate');
            var ajax_nav = window['ajax_nav_settings'],
            pg = parseInt(thePg) -1;
            if (pg < 0) {
                pg = 0;
            }
            var all_pages = window['pages'],
                qpages = all_pages[pg];

            axhr = $.ajax({
                url: ajax_url,
                timeout: 12000,
                type: 'POST',
                cache: false,
                data: ({
                    action: 'sc_get_paginated',
                    ids: qpages,
                    url: window.location.href,
                    current: thePg,
                    total: ajax_nav.total

                }),
                beforeSend: function(){
                    $('.products-loop').append('<div class="spinner"><div class="lds-dual-ring"></div></div>').addClass('loading');
                },
                success: function(data) {
                    var results = $.parseJSON(data);
                    if (results.products != undefined) {
                        $('#ajax-products').html(results.products)
                    }
                    if (results.pagination != undefined) {
                        $('nav.woocommerce-pagination.ajax-nav').html(results.pagination);
                        console.log(results);
                    }
                    $('.products-loop').removeClass('loading');
                    $('.spinner').remove();
                    getBulkSaveStatus();
                },
                error: function( jqXHR, textStatus, errorThrown ) {
                    console.log( 'The following error occured: ' + textStatus, errorThrown );
                },
                complete: function( jqXHR, textStatus ) {
                }
            });
        }


    //Document Ready ENDS
    });
})(jQuery);


/* Array to JSON */
function encodeJSON(fields) {
    var jsonLine = JSON.stringify(fields);
    return jsonLine;
}

/* JSON to array */
function decodeJSON(string) {
    var array = jQuery.parseJSON(string);
    return array;
}

function searchParams(url) {
    var params = {};
    var parser = document.createElement('a');
    parser.href = url;
    var query = parser.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
};